export const exteriorPaintRegions = [
  'walls',
  'trim',
  // TODO: restore this after adding support for scrolling the paint region tabs
  // 'fence',
  'door',
  'garage_door',
  'shutter',
] as const;

export const interiorPaintRegions = ['walls', 'cabinet', 'ceiling'] as const;
export const paintRegions = [
  ...exteriorPaintRegions,
  ...interiorPaintRegions,
] as const;

export const interiorMaterialRegions = ['floor', 'cabinet'] as const;
export const exteriorMaterialRegions = [
  'walls',
  'roof',
  'windows',
  'garage_door',
  'door',
  'trim',
] as const;
const materialRegions = [
  ...interiorMaterialRegions,
  ...exteriorMaterialRegions,
] as const;

export const regions = [...paintRegions, ...materialRegions] as const;

export type PaintRegion = (typeof paintRegions)[number];
export type MaterialRegion = (typeof materialRegions)[number];
export type MaterialRegionOrPaint = MaterialRegion | 'paint';
export type MaterialPaintRegions = (typeof regions | 'paint')[number];

export type Region = PaintRegion | MaterialRegion;
export type TopLevelRegion = 'walls' | MaterialRegion;

export interface CustomizePaint {
  type: 'paint';
  region: PaintRegion;
}

export interface CustomizeMaterial {
  type: 'material';
  region: MaterialRegion;
}

export type CustomizationCategory = CustomizePaint | CustomizeMaterial;

export type CustomizationType = CustomizationCategory['type'];

export const isCategoryEqual = (
  a: CustomizationCategory,
  b: CustomizationCategory,
) => {
  if (a.type === 'paint' && b.type === 'paint') return true;
  if (a.type === 'material' && b.type === 'material')
    return a.region === b.region;

  return false;
};
